import { render, staticRenderFns } from "./docsIndex.vue?vue&type=template&id=f89c50cc&scoped=true&"
import script from "./docsIndex.vue?vue&type=script&lang=js&"
export * from "./docsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89c50cc",
  null
  
)

export default component.exports